import { ArrowRight, ArrowUpRight } from "lucide-react";
import { CONTACT, INQUIRIES, inquiryMailto } from "../../data/content";
import { SectionHeading } from "../common";
import { Reveal } from "../Reveal";

export const InquiryRouting = () => (
    <section className="py-24 md:py-32" data-testid="inquiry-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="08"
                overline="Inquiries"
                title="Route it to the right desk."
                text="Every inquiry reaches a person. Choose the lane that fits."
            />
            <Reveal
                delay={0.05}
                className="mt-12 border border-thg-border bg-thg-surface p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
            >
                <div className="max-w-2xl">
                    <p className="font-display text-xl md:text-2xl font-medium text-white">
                        Have an operating problem that doesn&rsquo;t fit neatly into a dashboard?
                    </p>
                    <p className="mt-2 text-sm md:text-base leading-relaxed text-thg-secondary">
                        Put it in front of Titan Haven Group.
                    </p>
                </div>
                <a
                    href={inquiryMailto("Operational Intelligence / Strategic Engagement Inquiry")}
                    data-testid="home-engagement-cta"
                    className="inline-flex items-center gap-2 bg-thg-red text-white hover:bg-thg-redhover transition-colors duration-300 px-6 py-3 text-sm tracking-wide uppercase shrink-0"
                >
                    Start an Engagement <ArrowRight size={16} />
                </a>
            </Reveal>
            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-thg-border border border-thg-border">
                {INQUIRIES.map((item, i) => (
                    <Reveal key={item.name} delay={i * 0.05} className="bg-[#0a0a0a]">
                        <a
                            href={inquiryMailto(item.subject)}
                            data-testid={item.testId}
                            className="group flex flex-col justify-between h-full p-8 hover:bg-thg-surface transition-colors duration-300"
                        >
                            <div>
                                <h3 className="font-display text-lg md:text-xl font-medium text-white">{item.name}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-thg-secondary">{item.text}</p>
                            </div>
                            <span className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-thg-tertiary group-hover:text-white transition-colors duration-300">
                                Start inquiry
                                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </span>
                        </a>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2} className="mt-10 text-sm text-thg-tertiary">
                Direct:{" "}
                <a href={`mailto:${CONTACT.email}`} data-testid="inquiry-direct-email" className="text-thg-secondary hover:text-white transition-colors duration-300">
                    {CONTACT.email}
                </a>
                {"  "}&middot;{"  "}
                <a href={CONTACT.phoneHref} data-testid="inquiry-direct-phone" className="text-thg-secondary hover:text-white transition-colors duration-300">
                    {CONTACT.phone}
                </a>
            </Reveal>
        </div>
    </section>
);
